import type { IEntityMaskData } from '~/types/models'
import { parseNumericFieldValue } from '~/cynqueModules/dataObjects/Numeric'

interface IConvertNumericTextFieldTypeEntityMaskDataValueToNumber {
  callingFn: string
  ifield: IEntityMaskData
}

export function convertNumericTextFieldTypeEntityMaskDataValueToNumber(
  obj: IConvertNumericTextFieldTypeEntityMaskDataValueToNumber
): number | undefined {
  const fn =
    '[cynqueModules/convertNumericTextFieldTypeEntityMaskDataValueToNumber]'
  const { callingFn, ifield } = obj
  const { name, value } = ifield

  if (
    !['currencyTextField', 'numberTextField', 'percentageTextField'].includes(
      ifield.type
    )
  ) {
    return undefined
  }

  console.debug(
    `${callingFn} ----> ${fn} | name: ${name},` +
      ` value: ${value},` +
      ` typeof: ${typeof value}`
  )
  // if (value === null || value === undefined || value === '') {
  if (value === null || value === undefined) {
    // want '' to be converted to zero for now. JR.
    console.debug(
      `${callingFn} ----> ${fn} | name: ${name},` +
        ` No conversion. Returning undefined.`
    )
    return undefined
  }

  // Strip the field type's allowed decoration before converting, so an
  // appropriately-decorated paste (e.g. '$123,123.00' in a currency field) stores the
  // clean number (123123) rather than NaN. Falls back to Number() for already-clean
  // values, preserving the existing '' -> 0 behaviour; invalid values are blocked
  // upstream by the numeric validation rule.
  const parsedValue = parseNumericFieldValue(value, ifield.type)
  const convertedValue = parsedValue !== null ? parsedValue : Number(value)

  console.debug(
    `${callingFn} ----> ${fn} | name: ${name},` +
      ` converted value: ${convertedValue},` +
      ` typeof: ${typeof convertedValue}`
  )
  return convertedValue
}
